import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Banners } from '@sorare/core/src/components/layout/Banners';
import { MobileAppBottomPortalReceiver } from '@sorare/core/src/components/navigation/AppNavigation';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { LIFECYCLE } from '@sorare/core/src/hooks/useLifecycle';
import useQueryString from '@sorare/core/src/hooks/useQueryString';
import { useTitleAndDescription } from '@sorare/core/src/hooks/useTitleAndDescription';
import useTour from '@sorare/core/src/hooks/useTour';
import { createCardSorts } from '@sorare/core/src/lib/algolia';
import { metadatas } from '@sorare/core/src/lib/seo/nba';

import { MarketRoot } from '@sorare/marketplace/src/components/market/ui';
import useDefaultFilters from '@sorare/marketplace/src/hooks/useDefaultFilters';

import { MissingCards } from 'components/leaderboard/MissingCards';
import { NBACardSearch } from 'components/searchCards/NBACardSearch';
import { primaryMarketFilters } from 'components/searchCards/cardFilters';

const Content = styled(Vertical).attrs({ gap: 2 })``;

const PrimaryMarket = () => {
  const { isIosApp } = useIsMobileApp();
  const leaderboardSlug = useQueryString('leaderboard');

  useTitleAndDescription(
    metadatas.newSignings.title,
    metadatas.newSignings.description
  );

  const cardSorts = createCardSorts({
    indexPrefix: 'Cards On Sale',
    withHighestAverageScore: true,
  });

  const defaultSort = 'Cards On Sale Ending Soon';

  const filters = useDefaultFilters({
    primary: true,
    excludePrimaryOffers: true,
  });

  return (
    <>
      {!isIosApp && <Banners />}
      <MarketRoot>
        <Content>
          {leaderboardSlug && (
            <MissingCards leaderboardSlug={leaderboardSlug} />
          )}

          <NBACardSearch
            sorts={cardSorts}
            defaultSort={defaultSort}
            cardFilters={primaryMarketFilters}
            defaultFilters={filters}
            analyticsTags={['NewSignings', 'NBA']}
            onlyPrimary
            removeFinishedAuctions
            filtersTour={useTour(LIFECYCLE.newSignings, 'filters')}
            cardsTour={useTour(LIFECYCLE.newSignings, 'cards')}
            hideSorareUser
          />
        </Content>
      </MarketRoot>
      {isIosApp && (
        <MobileAppBottomPortalReceiver id="above-bottom-bar-portal" />
      )}
    </>
  );
};
export default PrimaryMarket;
